<div class="import-tip">
  <i class="ph ph-lightbulb import-tip__icon" aria-hidden="true"></i>
  <div class="import-tip__content">
    <p class="import-tip__lead">
      <span class="import-tip__lead-label">{{ 'tenders.responses.documents.import-tip.lead-label' | translate }}</span>
      {{ 'tenders.responses.documents.import-tip.lead' | translate }}
    </p>
    <p class="import-tip__body">
      {{ 'tenders.responses.documents.import-tip.body-before' | translate }}
      <span class="import-tip__action">{{ 'tenders.responses.documents.add-to-library' | translate }}</span>
      {{ 'tenders.responses.documents.import-tip.body-after' | translate }}
    </p>
  </div>
  <button
    type="button"
    class="import-tip__close"
    (click)="dismiss.emit(); $event.stopPropagation()"
    [attr.aria-label]="'tenders.responses.documents.import-tip.dismiss' | translate"
  >
    <i class="ph ph-x" aria-hidden="true"></i>
  </button>
</div>
